import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ConnectivityUnloadIcon = ({
  color,
  height = 32,
  width = 32,
  ...rest
}: {
  color?: string;
  height?: number;
  width?: number;
}) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorPrimary;

  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5ZM3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16Z"
        fill={currentColor}
      />
      <path
        d="M26.1018 11.6173L9.16998 7.38433C11.0477 5.89172 13.4245 5 16.0096 5C20.5269 5 24.4083 7.72306 26.1018 11.6173Z"
        fill={currentColor}
      />
      <path
        d="M9.16992 24.613C11.0476 26.1056 13.4244 26.9973 16.0095 26.9973C20.5269 26.9973 24.4083 24.2742 26.1017 20.38L9.16992 24.613Z"
        fill={currentColor}
      />
    </svg>
  );
};

export default ConnectivityUnloadIcon;
